import React from 'react';
import Chip, { ChipRow } from '../ui/Chip';

export default function OpportunityFilters({ filter, setFilter, sortBy, setSortBy, totalCount }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <ChipRow>
        <Chip active={filter === 'active'} onClick={() => setFilter('active')}>Active</Chip>
        <Chip active={filter === 'dismissed'} onClick={() => setFilter('dismissed')}>Dismissed</Chip>
        <Chip active={filter === 'all'} onClick={() => setFilter('all')}>All</Chip>
      </ChipRow>

      <div className="flex items-center gap-2 text-sm">
        <span className="text-secondary whitespace-nowrap">
          {totalCount} {totalCount === 1 ? 'opportunity' : 'opportunities'}
        </span>
        <label className="sr-only" htmlFor="opp-sort">Sort by</label>
        <select
          id="opp-sort"
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          className="input input-sm w-auto rounded-full pr-8"
        >
          <option value="score">Score</option>
          <option value="date">Newest</option>
          <option value="discount">Discount</option>
        </select>
      </div>
    </div>
  );
}
